export const SET_CART = "SET_CART";
export const UPDATE_CART_ITEMS = "UPDATE_CART_ITEMS";
export const ADD_TO_CART = "ADD_TO_CART";
export const SET_TOTAL_PRICE = "SET_TOTAL_PRICE";
export const SET_COUPON = "SET_COUPON";
export const SET_INSTALLMENTS = "SET_INSTALLMENTS";
export const RESET_CART = "RESET_CART";
export const SET_REBATE = 'SET_REBATE';
export const SET_BALANCE = 'SET_BALANCE';
export const SET_DEPOSIT = 'SET_DEPOSIT';
export const SET_CREDIT = 'SET_CREDIT';